const client = {
  // latest with fixes
  projectId: "031df324-fb7a-43ae-a55d-56e819f62880",
  modelId: "5137f0c0-389d-4aae-9b4b-de9ee52cb85b",
  useNativeTouchEvents: true,
  usePointerLock: true,
  pointerLockRelease: false,
};

export default client;
